import Bone from "../../../Components/Skeleton/Bone"

import styles from "./lookupFlowSkeleton.module.less"

// Node shares per column: all lookups, program, channel, outcome.
const COLUMNS = [[1], [0.56, 0.44], [0.5, 0.14, 0.36], [0.8, 0.2]]

// The Sankey's frame while flow/ loads: its 420px height and margins, the four columns, and a
// bar with the three-line label (count, name, share) beside every node.
const LookupFlowSkeleton = () => (
  <div className={styles.flow}>
    {COLUMNS.map((nodes, c) => (
      <div key={c} className={styles.column}>
        {nodes.map((share, n) => (
          <div key={n} className={styles.node} style={{ flexGrow: share }}>
            <Bone width={12} height="100%" className={styles.bar} />
            <div className={styles.label}>
              <Bone width={64} height={14} />
              <Bone width={96} height={14} />
              <Bone width={72} height={12} />
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
)

export default LookupFlowSkeleton
